import React from 'react';

type CardVariant = 'default' | 'glass' | 'outline' | 'elevated' | 'flat';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: CardVariant;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  children: React.ReactNode;
}

const variantClasses: Record<CardVariant, string> = {
  default: 'bg-[#fbfaf6] border border-[#e6e0d2] shadow-card',
  glass: 'bg-black/40 backdrop-blur-md border border-brand-800/50 text-white',
  outline: 'bg-transparent border border-white/10 text-white',
  elevated: 'bg-[#fbfaf6] border border-[#e6e0d2] shadow-lg',
  flat: 'bg-[#f4f1e8] border border-[#e2dbca]',
};

const paddingClasses = {
  none: '',
  sm: 'p-3',
  md: 'p-4',
  lg: 'p-5',
};

export const Card: React.FC<CardProps> = ({
  variant = 'default',
  padding = 'md',
  children,
  className = '',
  ...props
}) => {
  const classes = [
    'rounded-2xl',
    variantClasses[variant],
    paddingClasses[padding],
    className,
  ].join(' ');

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};

export default Card;
